import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

/** Shows an example AI request travelling through MCP to Fleet. */
@Component({
  selector: 'mcp-visual',
  standalone: true,
  imports: [MatIconModule],
  templateUrl: './mcp-visual.component.html',
  styleUrl: './mcp-visual.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class McpVisualComponent {}
